<template>
  <div>
    <div class="content">
      <div class="contBox">
        <div class="titleBox">
          <div class="name">
            工作台
            <span
              style="margin-left: 10px; color: #ee0909; cursor: pointer"
              @click="xiazaiWd"
              >操作有不懂的？点击下载企业操作文档</span
            >
          </div>
          <div class="vipTime" v-if="vipInfo.vip.setmeal_name">
            {{ vipInfo.vip.setmeal_name }}到期时间<span>{{
              daysNum <= 0 ? 0 : daysNum
            }}</span
            >天
          </div>
          <div class="anniu" @click="rengzhengOk" v-if="audit == 0">
            认证失败，点击重新认证
          </div>
        </div>
        <div class="gzCont">
          <div class="gzBox" @click="jlClick">
            <div class="name">未看简历数</div>
            <div class="num">
              <span>{{ company_workInfo.resumes }}</span
              >条
            </div>
          </div>
          <!-- <div class="gzBox" @click="xxClick">
            <div class="name">未查看消息</div>
            <div class="num">
              <span>{{ company_workInfo.message }}</span>条
            </div>
          </div> -->
          <div class="gzBox" @click="msLsClick">
            <div class="name">面试收藏数</div>
            <div class="num">
              <span>{{ company_workInfo.interviewall }}</span
              >条
            </div>
          </div>
          <div class="gzBox" @click="msClick">
            <div class="name">未面试数量</div>
            <div class="num">
              <span>{{ company_workInfo.interview }}</span
              >条
            </div>
          </div>
          <div class="gzBox" @click="zphClick">
            <div class="name">近期招聘会</div>
            <div class="time" v-if="company_workInfo.recruit">
              {{ company_workInfo.recruit[0].start_time }}
            </div>
          </div>
          <div class="gzBox">
            <div class="name">急聘时间剩余</div>
            <div class="num">
              <span>{{ vipInfo.vip.worry_time }}</span
              >小时
            </div>
          </div>
          <div class="gzBox">
            <div class="name">免费线下窗口广告宣传剩余</div>
            <div class="num">
              <span>{{
                vipInfo.vip.advert - company_workInfo.advert < 0
                  ? 0
                  : vipInfo.vip.advert - company_workInfo.advert
              }}</span
              >次
            </div>
          </div>
          <div class="gzBox">
            <div class="name">免费公众号发布剩余</div>
            <div class="num">
              <span>{{ vipInfo.vip.public - company_workInfo.official }}</span
              >次
            </div>
          </div>
          <div class="gzBox">
            <div class="name">定制展架次数</div>
            <div class="num">
              <span>{{ rack }}</span
              >次
            </div>
          </div>
        </div>
        <div class="titleBox zuoTxt">
          <div class="name">会员升级</div>
          <div class="fpText dis-cent" v-if="fpInfo.id" @click="fpClick">
            <a :href="$imgUrl + fpInfo.resource" download>最新发票下载</a>
          </div>
        </div>
        <div class="tuijianCont">
          <div class="box" v-for="item in vipInfo.viplist">
            <div class="textBox">
              <div class="name">{{ item.setmeal_name }}</div>
              <div class="text c-1">{{ item.added }}</div>
            </div>
            <div class="btn dis-cent" @click="payClick(item.id)">购买</div>
          </div>
        </div>
        <div class="titleBox">
          <div class="name">服务申请</div>
        </div>
        <div class="tuijianCont" style="margin-bottom: 10px">
          <div class="box">
            <div class="textBox">
              <div class="name">
                线下招聘窗口广告宣传<span style="color: red">(50元/次)</span>
              </div>
              <div class="text c-1">可以在线下招聘窗口发布广告</div>
            </div>
            <div class="btn dis-cent" @click="xianxiaClick(1)">申请</div>
          </div>
          <div class="box">
            <div class="textBox">
              <div class="name">
                首页招聘新闻广告宣传<span style="color: red">(200元/次)</span>
              </div>
              <div class="text c-1">可以在线下招聘窗口发布广告</div>
            </div>
            <div class="btn dis-cent" @click="xianxiaClick(2)">申请</div>
          </div>
          <div class="box">
            <div class="textBox">
              <div class="name">
                名企展示<span style="color: red">(380元/年)</span>
              </div>
              <div class="text c-1">可以在首页直接推荐公司</div>
            </div>
            <div class="btn dis-cent" @click="mqvisible = true">申请</div>
          </div>
          <div class="box">
            <div class="textBox">
              <div class="name">公众号发布</div>
              <div class="text c-1">在玉环人才公众号发布广告</div>
            </div>
            <div class="btn dis-cent" @click="gchShow = true">申请</div>
          </div>
        </div>
        <div class="titleBox2" style="margin-top: 0" v-if="daysNum > 0">
          <div class="name">权益消耗</div>
          <div class="name">
            <!-- 会员到期时间还剩 <span>{{ daysNum }}</span> 天 -->
          </div>
        </div>
        <div class="qyCont" v-if="daysNum > 0">
          <div class="cont">
            <div class="name">
              发布岗位次数
              <span
                class="iconfont icon-feedback"
                :title="'成为人力网会员后增加的权益'"
              ></span>
            </div>
            <div class="box">
              <div class="text">剩余次数</div>
              <div class="ktBox">
                <div class="cianchong" :style="'width:' + xxWi + '%;'"></div>
              </div>
              <div class="nums">
                {{ vipInfo.postjob }} / {{ vipInfo.vip.jobs_meanwhile }}
              </div>
            </div>
          </div>
          <div class="cont">
            <div class="name">
              下载简历次数
              <span
                class="iconfont icon-feedback"
                :title="'用于查看求职者下载简历的次数'"
              ></span>
            </div>
            <div class="box">
              <div class="text">剩余次数</div>
              <div class="ktBox">
                <div class="cianchong" :style="'width:' + xzWi + '%;'"></div>
              </div>
              <div class="nums">
                {{ vipInfo.down }}
                / {{ vipInfo.vip.download_resume }}
              </div>
            </div>
          </div>
        </div>
        <div class="headCont">
          <div class="typeList">
            <div
              class="type dis-cent"
              :class="item.type == ztOn ? 'on' : ''"
              v-for="item in zongTime"
              @click="ztClick(item.type)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="titleBox">
          <div class="name">数据概览</div>
        </div>
        <div class="tjCont">
          <div class="box" :class="kgType == 0 ? 'on' : ''" @click="kgClick(0)">
            <div class="title">我看过</div>
            <div class="num">{{ info.readmeber }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastreadmember >= 0
                  ? "+ " + info.lastreadmember
                  : info.lastreadmember
              }}</span>
            </div>
          </div>
          <div
            class="box lan"
            :class="kgType == 1 ? 'lanon' : ''"
            @click="kgClick(1)"
          >
            <div class="title">看过我</div>
            <div class="num">{{ info.readcompany }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastreadcompany >= 0
                  ? "+ " + info.lastreadcompany
                  : info.lastreadcompany
              }}</span>
            </div>
          </div>
          <div
            class="box danlan"
            :class="kgType == 2 ? 'danlanon' : ''"
            @click="kgClick(2)"
          >
            <div class="title">我沟通</div>
            <div class="num">{{ info.chatmessage }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastchatmessage >= 0
                  ? "+ " + info.lastchatmessage
                  : info.lastchatmessage
              }}</span>
            </div>
          </div>
          <div
            class="box zi"
            :class="kgType == 3 ? 'zion' : ''"
            @click="kgClick(3)"
          >
            <div class="title">收获简历</div>
            <div class="num">{{ info.interview }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastinterview >= 0
                  ? "+ " + info.lastinterview
                  : info.lastinterview
              }}</span>
            </div>
          </div>
          <div
            class="box lan"
            :class="kgType == 4 ? 'lanon' : ''"
            @click="kgClick(4)"
          >
            <div class="title">交换微信</div>
            <div class="num">{{ info.wechat }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastwechat >= 0 ? "+ " + info.lastwechat : info.lastwechat
              }}</span>
            </div>
          </div>
          <div
            class="box zi"
            :class="kgType == 5 ? 'zion' : ''"
            @click="kgClick(5)"
          >
            <div class="title">交换电话</div>
            <div class="num">{{ info.phone }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastphone >= 0 ? "+ " + info.lastphone : info.lastphone
              }}</span>
            </div>
          </div>
          <div class="box" :class="kgType == 6 ? 'on' : ''" @click="kgClick(6)">
            <div class="title">面试申请</div>
            <div class="num">{{ info.resumes }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastresumes >= 0
                  ? "+ " + info.lastresumes
                  : info.lastresumes
              }}</span>
            </div>
          </div>
          <div
            class="box danlan"
            :class="kgType == 7 ? 'danlanon' : ''"
            @click="kgClick(7)"
          >
            <div class="title">接受面试</div>
            <div class="num">{{ info.interviewtong }}</div>
            <div class="text">
              {{
                ztOn == "day" ? "较昨日" : ztOn == "week" ? "较上周" : "较上月"
              }}
              <span>{{
                info.lastinterviewtong >= 0
                  ? "+ " + info.lastinterviewtong
                  : info.lastinterviewtong
              }}</span>
            </div>
          </div>
        </div>
        <div class="titleBox1">
          <div class="name">
            {{
              kgType == 0
                ? "我看过"
                : kgType == 1
                ? "看过我"
                : kgType == 2
                ? "我沟通"
                : kgType == 3
                ? "收获简历"
                : kgType == 4
                ? "交换微信"
                : kgType == 5
                ? "交换电话"
                : kgType == 6
                ? "面试申请"
                : "接受面试"
            }}的近期趋势
          </div>
          <div class="typeList">
            <div
              class="type dis-cent"
              :class="item.id == qsOn ? 'on' : ''"
              v-for="item in qsList"
              @click="qsClick(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="qsConr">
          <Qushi :manageList="manageList" />
        </div>
        <div class="titleBox" style="margin-top: 20px">
          <div class="name">公共服务</div>
        </div>
        <div class="ggFunBox">
          <div class="btn dis-cent">
            <div class="iconfont icon-order_fill icon"></div>
            <div class="name">社保查询</div>
            <div class="iconfont icon-enter"></div>
          </div>
          <div class="btn yanse1 dis-cent">
            <div class="iconfont icon-gaojichaxun icon1"></div>
            <div class="name">档案查询</div>
            <div class="iconfont icon-enter"></div>
          </div>
          <div class="btn yanse2 dis-cent">
            <div class="iconfont icon-jieshou1 icon2"></div>
            <div class="name">档案接收</div>
            <div class="iconfont icon-enter"></div>
          </div>
          <div class="btn yanse3 dis-cent">
            <div class="iconfont icon-zhuanchu icon3"></div>
            <div class="name">档案转出</div>
            <div class="iconfont icon-enter"></div>
          </div>
          <div class="btn yanse4 dis-cent">
            <div class="iconfont icon-zhicheng icon4"></div>
            <div class="name">安居自助</div>
            <div class="iconfont icon-enter"></div>
          </div>
        </div>
        <!-- <div class="titleBox">
          <div class="name">为你推荐</div>
        </div>
        <div class="tuijianCont">
          <div class="box">
            <div class="textBox">
              <div class="name">线下招聘窗口广告宣传(次/月)</div>
              <div class="text c-1"></div>
            </div>
            <div class="btn dis-cent" @click="payClick(item.id)">购买</div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="h-70"></div>
    <XxzpSave v-if="xxShow" :type="ggType" @show="xxzDelClick" />
    <GchSave v-if="gchShow" @show="gchzDelClick" />
    <a-modal
      v-model="visible"
      title="提示"
      @ok="handleOk"
      cancelText="取消"
      okText="确定"
    >
      <p>您的免费次数已经用完，是否前往支付后发布该申请。</p>
    </a-modal>
    <a-modal
      v-model="mqvisible"
      title="提示"
      @ok="mqhandleOk"
      cancelText="取消"
      okText="确定"
    >
      <p>在首页推荐您的公司需要支付380元/年，是否前往</p>
    </a-modal>
    <a-modal
      v-model="rengzheng"
      title="提示"
      @ok="rengzhengOk"
      cancelText="取消"
      okText="确定"
    >
      <p>
        您的公司认证失败，失败原因为：<span style="color: #ee0909">{{
          remarks
        }}</span>
      </p>
      <p>请重新前往认证</p>
    </a-modal>
  </div>
</template>

<script>
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  Popconfirm,
  Modal,
} from "ant-design-vue";
import { notification } from "ant-design-vue";
import Qushi from "../component/qushi.vue";
import XxzpSave from "../component/xxzpSave.vue";
import GchSave from "../component/gchSave.vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
    Qushi,
    XxzpSave,
    GchSave,
  },
  name: "",
  data() {
    return {
      ggType: 0,
      mqvisible: false,
      visible: false,
      xxShow: false,
      gchShow: false,
      ztOn: "day",
      zongTime: [
        {
          type: "day",
          name: "日报",
        },
        {
          type: "week",
          name: "周报",
        },
        {
          type: "month",
          name: "月报",
        },
      ],
      xzKey: "",
      info: {},
      qsOn: 1,
      qsList: [
        {
          id: 1,
          name: "近7天",
        },
        {
          id: 2,
          name: "近15天",
        },
        {
          id: 3,
          name: "近30天",
        },
      ],
      manageList: [],
      vipInfo: {
        vip: {},
        viplist: [],
      },
      xxWi: 0,
      xzWi: 0,
      daysNum: 0,
      kgType: 0,
      order_id: "",
      company_workInfo: {},
      rack: 0,
      fpInfo: {},
      rengzheng: false,
      remarks: "",
      audit: 0,
    };
  },
  created() {
    this.get();
    this.manageget();
    this.company_workget();
    let token = this.$route.query.Authorization;
    if (token) {
      window.localStorage.setItem("utype", 1);
      window.localStorage.setItem("rlToken", token);
      window.location.href = "https://www.yhrl.com/#/index";
    }
    this.company_invoice_get();
  },
  methods: {
    xiazaiWd() {
      window.location.href = "https://www.yhrl.com/static/company/caozuo.docx";
    },
    rengzhengOk() {
      // this.$router.push({
      //   path: "/gongsi/comRenzheng",
      //   query: {},
      // });
      window.open("#/gongsi/comRenzheng");
    },
    company_invoice_get() {
      this.$get("/nozzle/web/company_invoice_get").then((res) => {
        this.fpInfo = res.data;
      });
    },
    fpClick() {
      this.$get("/nozzle/web/company_invoice_down", {
        id: this.fpInfo.id,
      }).then((res) => {
        console.log(res);
      });
    },
    xianxiaClick(type) {
      this.ggType = type;
      this.xxShow = true;
    },
    jlClick() {
      // this.$router.push({
      //   path: "/gongsi/tjrcIndex",
      //   query: {},
      // });
      window.open("#/gongsi/tjrcIndex");
    },
    xxClick() {
      this.$router.push({
        path: "/gongsi/message",
        query: {},
      });
      // window.open("#/gongsi/message");
    },
    msLsClick() {
      // this.$router.push({
      //   path: "/gongsi/msList",
      //   query: {},
      // });
      window.open("#/gongsi/msList");
    },
    msClick() {
      // this.$router.push({
      //   path: "/gongsi/mianshi",
      //   query: {},
      // });
      window.open("#/gongsi/mianshi");
    },
    zphClick() {
      // this.$router.push({
      //   path: "/gongsi/gsZhaoping",
      //   query: {},
      // });
      window.open("#/gongsi/gsZhaoping");
    },
    xxzDelClick(data) {
      this.xxShow = false;
      if (data) {
        if (data.data.order_id) {
          this.order_id = data.data.order_id;
          this.visible = true;
        }
      }
    },
    gchzDelClick(data) {
      this.gchShow = false;
    },
    kgClick(i) {
      this.kgType = i;
      this.manageget();
    },
    company_workget() {
      this.$get("/nozzle/web/company_work").then((res) => {
        console.log(res);
        res.recruit[0].start_time = this.$moment(
          res.recruit[0].start_time
        ).format("YYYY年M月D日");
        if (res.audit == 0) {
          this.rengzheng = true;
          this.remarks = res.remarks;
        }
        this.audit = res.audit;
        this.company_workInfo = res;
        this.vipget();
      });
    },
    vipget() {
      this.$get("/nozzle/web/company_vip").then((res) => {
        console.log(res);

        this.vipInfo = res;
        this.xxWi = ((res.postjob / res.vip.jobs_meanwhile) * 100).toFixed(0);
        this.xzWi = ((res.down / res.vip.download_resume) * 100).toFixed(0);
        let startDate = this.$moment().format();
        let dateTimeStamp = this.$moment(res.vip.endtime * 1000).format();
        dateTimeStamp = this.$moment(dateTimeStamp);
        this.daysNum = dateTimeStamp.diff(startDate, "days");
        if (this.audit == 1) {
          if (this.daysNum > 0 && this.daysNum <= 7) {
            notification.error({
              message: "提示",
              description: "会员还有" + this.daysNum + "到期，请尽快续费",
              duration: 10, // 设置通知持续时间（秒）
            });
          } else if (this.daysNum <= 0) {
            notification.error({
              message: "提示",
              description: "会员已到期，请尽快续费",
              duration: 10, // 设置通知持续时间（秒）
            });
          }
        }
      });
      this.$get("/nozzle/web/recruit_sign_before").then((res) => {
        this.rack = res.rack;
      });
    },
    payClick(id) {
      this.$post("/nozzle/web/company_buy_vip", {
        setmeal_id: id,
      }).then((res) => {
        if (res.data.status == 1) {
          // this.$router.push({
          //   path: "/pay",
          //   query: {
          //     id: res.data.data,
          //   },
          // });
          window.open("#/pay?id=" + res.data.data);
        }
      });
    },
    get() {
      this.$get("/nozzle/web/company_statistics", {
        type: this.ztOn,
      }).then((res) => {
        this.info = res;
        res.lastreadmember = Number(res.readmeber) - Number(res.lastreadmember);
        res.lastreadcompany =
          Number(res.readcompany) - Number(res.lastreadcompany);
        res.lastchatmessage =
          Number(res.chatmessage) - Number(res.lastchatmessage);
        res.lastinterview = Number(res.interview) - Number(res.lastinterview);
        res.lastwechat = Number(res.wechat) - Number(res.lastwechat);
        res.lastphone = Number(res.phone) - Number(res.lastphone);
        res.lastresumes = Number(res.resumes) - Number(res.lastresumes);
        res.lastinterviewtong =
          Number(res.interviewtong) - Number(res.lastinterviewtong);
      });
    },
    manageget() {
      this.$get("/nozzle/web/company_graphs", {
        type: this.qsOn,
        class: this.kgType + 1,
      }).then((res) => {
        for (let i = 0; i < res.charts.length; i++) {
          const e = res.charts[i];
          e.value = e.number;
        }
        this.manageList = res.charts;
      });
    },
    ztClick(i) {
      this.ztOn = i;
      this.get();
    },
    qsClick(id) {
      this.qsOn = id;
      this.manageget();
    },
    hyClick(e) {
      this.xzKey = e.key;
    },
    handleOk() {
      this.visible = false;
      // this.$router.push({
      //   path: "/pay",
      //   query: {
      //     id: this.order_id,
      //   },
      // });
      window.open("#/pay?id=" + this.order_id);
    },
    mqhandleOk() {
      this.$post("/nozzle/web/famous_company").then((res) => {
        if (res.data.status == 1) {
          // this.$router.push({
          //   path: "/pay",
          //   query: {
          //     id: res.data.data,
          //   },
          // });
          window.open("#/pay?id=" + res.data.data);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  width: 1280px;
  margin: auto;
  padding-top: 10px;

  .headCont {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;

    .typeList {
      display: flex;
      align-items: center;

      .type {
        width: 50px;
        height: 30px;
        cursor: pointer;
        border-radius: 5px;
      }

      .on {
        background-color: #dcebfc;
        color: #167edf;
      }
    }

    .zwSelect {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      border-radius: 5px;
      height: 30px;
      width: 200px;
      padding: 0 10px;
      cursor: pointer;

      .name {
        font-size: 12px;
        width: calc(100% - 20px);
      }

      .iconfont {
        font-size: 12px;
      }
    }
  }

  .ggFunBox {
    box-sizing: border-box;
    display: flex;
    padding-top: 15px;
    margin-bottom: 10px;

    .btn {
      height: 62px;
      // background-color: #28dc82;
      background: linear-gradient(to right, #28dc82, #18cc72);
      color: #fff;
      border-radius: 5px;
      // margin-bottom: 15px;
      position: relative;
      cursor: pointer;
      flex: 1;
      margin-right: 10px;

      .name {
        font-size: 16px;
      }

      .icon {
        bottom: -25px;
        left: 5px;
        font-size: 65px;
        opacity: 0.4;
        transform: rotate(-20deg);
        position: absolute;
      }

      .icon1 {
        bottom: -25px;
        left: 5px;
        font-size: 65px;
        opacity: 0.4;
        // transform: rotate(-20deg);
        position: absolute;
      }

      .icon2 {
        bottom: -20px;
        left: 5px;
        font-size: 50px;
        opacity: 0.4;
        // transform: rotate(-20deg);
        position: absolute;
      }

      .icon3 {
        bottom: -25px;
        left: 10px;
        font-size: 55px;
        opacity: 0.4;
        transform: rotate(-20deg);
        position: absolute;
      }

      .icon4 {
        bottom: -25px;
        left: -5px;
        font-size: 65px;
        opacity: 0.4;
        // transform: rotate(-20deg);
        position: absolute;
      }

      .icon5 {
        bottom: -20px;
        left: 0px;
        font-size: 60px;
        opacity: 0.4;
        // transform: rotate(-20deg);
        position: absolute;
      }
    }

    .btn:last-child {
      margin-right: 0;
    }

    .yanse1 {
      background: linear-gradient(to right, #45b1ff, #2a89ce);
    }

    .yanse2 {
      background: linear-gradient(to right, #ffb249, #e2952a);
    }

    .yanse3 {
      background: linear-gradient(to right, #45a5ff, #3499eb);
    }

    .yanse4 {
      background: linear-gradient(to right, #f59352, #e06e39);
    }

    .yanse5 {
      background: linear-gradient(to right, #45c4ff, #45c4ff);
    }
  }

  .gzCont {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 0 0;

    .gzBox {
      border-top: 2px solid #93c6f7;
      width: calc(25% - 15px);
      height: 80px;
      margin-right: 20px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      box-shadow: 0 8px 8px 4px #f3f8fd;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      margin-bottom: 25px;
      cursor: pointer;

      .name {
        font-weight: 600;
        font-size: 16px;
      }

      .num {
        position: relative;
        top: -4px;

        span {
          color: #e02a2a;
          font-weight: 600;
          font-size: 26px;
          margin-right: 2px;
        }
      }

      .time {
        color: #288eec;
      }
    }

    .gzBox:nth-child(4n) {
      margin-right: 0;
    }
  }

  .contBox {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;

    .titleBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .anniu {
        background-color: #e20a0a;
        color: #fff;
        height: 35px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 15px;
        cursor: pointer;
      }
      .name {
        font-weight: 600;
        font-size: 18px;
      }

      .fpText {
        cursor: pointer;
        color: #fff;
        background-color: #e02a2a;
        width: 100px;
        height: 35px;
        border-radius: 5px;
        margin-left: 20px;
        a {
          color: #fff;
        }
      }

      .vipTime {
        font-weight: 600;
        font-size: 18px;

        span {
          color: #167edf;
          font-weight: 700;
          font-size: 20px;
          margin: 0 3px;
        }
      }

      .select {
        height: 30px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        background-color: #f1f1f1;
        width: 120px;
        margin-left: 20px;
        justify-content: space-between;
        padding: 0 10px;
        color: #1f2b3a;

        .iconfont {
          font-size: 14px;
        }
      }
    }

    .zuoTxt {
      justify-content: flex-start;
    }

    .tjCont {
      display: flex;
      flex-wrap: wrap;
      margin-top: 15px;

      .box {
        cursor: pointer;
        width: calc(25% - 15px);
        margin-right: 20px;
        box-sizing: border-box;
        padding: 15px 20px;
        height: 120px;
        background-color: #eafafa;
        border: 1px solid #eafafa;
        border-radius: 10px;
        margin-bottom: 20px;

        .title {
          font-size: 14px;
        }

        .num {
          font-size: 30px;
          font-weight: 600;
          margin-bottom: 5px;
          color: #1f2b3a;
        }

        .text {
          font-size: 12px;
          color: #666;
        }
      }

      .box:hover {
        animation: 0.3s both yingyin;
      }

      @keyframes yingyin {
        0% {
          box-shadow: 0 0 0 0 #ebebeb;
        }

        100% {
          box-shadow: 0 8px 14px 4px #ebebeb;
        }
      }

      .box:nth-child(4n) {
        margin-right: 0;
      }

      .on {
        border: 1px solid #13a8a8;
      }

      .lan {
        background-color: #ebf2fd;
        border: 1px solid #ebf2fd;
      }

      .lanon {
        border: 1px solid #2157af;
      }

      .danlan {
        background-color: #ebf7fd;
        border: 1px solid #ebf7fd;
      }

      .danlanon {
        border: 1px solid #1facf3;
      }

      .zi {
        background-color: #f6f7ff;
        border: 1px solid #f6f7ff;
      }

      .zion {
        border: 1px solid #4a23b6;
      }
    }

    .titleBox1 {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .name {
        font-weight: 600;
        font-size: 18px;
      }

      .typeList {
        height: 35px;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        display: flex;
        overflow: hidden;

        .type {
          height: 35px;
          width: 60px;
          box-sizing: border-box;
          border-right: 1px solid #ebebeb;
          cursor: pointer;
          font-size: 12px;
          position: relative;
          top: -1px;
        }

        .type:last-child {
          border-right: none;
        }

        .on {
          color: #167edf;
          background-color: #e9f5ff;
        }
      }
    }

    .qsConr {
      height: 300px;
      color: #1f2b3a;
    }

    .titleBox2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;

      .name {
        font-weight: 600;
        font-size: 18px;

        span {
          font-weight: 900;
          color: #e20a0a;
          font-size: 20px;
        }
      }
    }

    .qyCont {
      display: flex;
      margin-top: 10px;
      margin-bottom: 20px;

      .cont {
        flex: 1;
        padding-right: 50px;

        .name {
          display: flex;
          align-items: center;

          .iconfont {
            font-size: 20px;
            position: relative;
            top: 1px;
            margin-left: 5px;
            cursor: pointer;
          }
        }

        .box {
          display: flex;
          align-items: center;
          margin-top: 15px;
          color: rgb(101, 108, 117);

          .text {
            width: 85px;
          }

          .ktBox {
            width: calc(100% - 150px);
            height: 16px;
            border-radius: 5px;
            background-color: whitesmoke;
            overflow: hidden;

            .cianchong {
              width: 70%;
              height: 100%;
              background-color: #e02a2a;
            }
          }

          .nums {
            width: 65px;
            text-align: right;
          }
        }
      }

      .cont:last-child {
        padding-right: 0;
      }
    }

    .tuijianCont {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 15px;

      .box {
        border: 1px solid #ebebeb;
        border-radius: 10px;
        padding: 15px;
        width: calc(33.33% - 13.33px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 20px;
        margin-bottom: 15px;

        .textBox {
          width: calc(100% - 80px);

          .name {
            font-size: 16px;
          }

          .text {
            color: #666;
            margin-top: 5px;
            padding-right: 15px;
          }
        }

        .btn {
          height: 30px;
          width: 80px;
          border-radius: 30px;
          background-color: #1d8ef8;
          color: #fff;
          cursor: pointer;
        }
      }

      .box:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
